/* import __COLOCATED_TEMPLATE__ from './sq-super-table-auto-viewport.hbs.js'; */
var _dec, _dec2, _dec3, _class, _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { classNames } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { reads } from '@ember/object/computed';
import Component from '@ember/component';
import $ from 'jquery';
let SqSuperTableAutoViewport = (_dec = classNames('super-table-auto-viewport'), _dec2 = reads('rowHeight'), _dec3 = computed('rowHeight', 'hasFooter', 'content.length'), _dec(_class = (_class2 = class SqSuperTableAutoViewport extends Component {
  constructor(...args) {
    super(...args);
    // parameters
    _defineProperty(this, "rowHeight", 0);
    // in px
    _defineProperty(this, "hasFooter", false);
    _defineProperty(this, "content", null);
    _initializerDefineProperty(this, "headerRowHeight", _descriptor, this);
    _defineProperty(this, "scrollParentSelector", 'window');
  }
  didInsertElement(...args) {
    super.didInsertElement(...args);
    const elementId = this.elementId;
    const $window = $(window); // eslint-disable-line ember/no-jquery
    $window.on(`resize.${elementId}`, this._resetHeight.bind(this));
    this._resetHeight();
  }
  didUpdateAttrs() {
    super.didUpdateAttrs();
    this._resetHeight();
  }
  willDestroyElement() {
    super.willDestroyElement();
    const elementId = this.elementId;
    $(window).off(`resize.${elementId}`); // eslint-disable-line ember/no-jquery
  }

  // note(seung): If the content is not larger than 100vh then there is no need
  // to have this wrapping container to be 100vh.
  // Dynamically adjust the height so we don't get large amounts of white space
  // under tables with little rows
  _resetHeight() {
    // New dashboard navbar at the top always takes up space so adjust viewport height if nav exists
    const viewportHeight = $(window).height() - this.navHeight; // eslint-disable-line ember/no-jquery
    const height = Math.min(viewportHeight, this.maxHeightPx);
    $(this.element).css({
      height: `${height}px`
    }); // eslint-disable-line ember/no-jquery
  }
  get maxHeightPx() {
    let rowCount = this.content.length || 0; // eslint-disable-line unicorn/explicit-length-check -- https://github.com/sindresorhus/eslint-plugin-unicorn/issues/980
    rowCount += this.hasFooter ? 1 : 0;
    return rowCount * this.rowHeight;
  }
  get navHeight() {
    // note(seung): I trust that the #sq-app-container's adjustment is more future proof
    // opposed to the actual height from the navbar's class.
    const marginTop = $('#sq-app-container').css('margin-top'); // eslint-disable-line ember/no-jquery
    return marginTop ? Number.parseInt(marginTop, 10) : 0;
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "headerRowHeight", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "maxHeightPx", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "maxHeightPx"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "navHeight", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "navHeight"), _class2.prototype), _class2)) || _class);
export { SqSuperTableAutoViewport as default };